import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { AgenziaModel } from '../../crm/modules/settings/models/agenzia.model';
import { AuthModel } from '../models/auth.model';
import { AuthStore, AuthState } from './auth.store';

@Injectable({ providedIn: 'root' })
export class AuthQuery extends Query<AuthState> {

  selectIsAuth$ = this.select('auth');
  selectIsAgenzia$ = this.select('agenzia');

  constructor(protected store: AuthStore) {
    super(store);
  }

  get auth(): AuthModel | undefined {
    return this.getValue().auth;
  }

  get agenzia(): AgenziaModel | undefined {
    return this.getValue().agenzia;
  }

}
